import * as React from 'react';

interface Props {
    url?: string;
    target?: string;
    className: string;
    onClick?: () => void;
    useTheme?: boolean;
    role?: string;
    ariaLabel?: string;
}

export default class Link extends React.PureComponent<Props, {}> {
    static defaultProps = {
        className: '',
        useTheme: false,
    };

    handleClick = (evt: React.MouseEvent): void => {
        const { onClick } = this.props;

        if (onClick) {
            evt.stopPropagation();
            evt.nativeEvent.stopImmediatePropagation();
            onClick();
        }
    };

    render() {
        const { className, url, children, target, useTheme, role, ariaLabel } = this.props;

        const classNames: Array<string> = ['ddbc-link', className];

        if (useTheme) {
            classNames.push('ddbc-theme-link');
        }

        return (
            <a
                href={url}
                target={target}
                className={classNames.join(' ')}
                onClick={this.handleClick}
                role={role}
                aria-label={ariaLabel}
            >
                {children}
            </a>
        );
    }
}
